// Stimulus
import { Application } from '@hotwired/stimulus';
import StimulusControllerResolver from 'stimulus-controller-resolver'; // eslint-disable-line import/no-unresolved

// Turbo
import * as Turbo from '@hotwired/turbo';

// Assets
import '../assets/img/albo-brand.svg';
import '../assets/img/albo-check.svg';
import '../assets/img/albo-mark.svg';
import '../assets/img/bg-shape.svg';
import '../assets/img/kite-slogan-secondary.svg';
import '../assets/img/kite-slogan-tertiary.svg';
import '../assets/img/kite.svg';
import '../assets/img/map-marker.svg';
import '../assets/img/wood.webp';

// Email assets
import '../assets/img/email/facebook.png';
import '../assets/img/email/instagram.png';
import '../assets/img/email/linkedin.png';
import '../assets/img/email/logo-mark.png';
import '../assets/img/email/logo.png';
import '../assets/img/email/pinterest.png';
import '../assets/img/email/tiktok.png';
import '../assets/img/email/youtube.png';

// Icons
import '../assets/img/icons/arrow-down.svg';
import '../assets/img/icons/arrow-left-circle.svg';
import '../assets/img/icons/arrows-up-down.svg';
import '../assets/img/icons/bars-2.svg';
import '../assets/img/icons/camera.svg';
import '../assets/img/icons/chevron-right.svg';
import '../assets/img/icons/clock.svg';
import '../assets/img/icons/download.svg';
import '../assets/img/icons/envelope.svg';
import '../assets/img/icons/eye.svg';
import '../assets/img/icons/facebook.svg';
import '../assets/img/icons/filter.svg';
import '../assets/img/icons/geo.svg';
import '../assets/img/icons/globe.svg';
import '../assets/img/icons/heart.svg';
import '../assets/img/icons/instagram.svg';
import '../assets/img/icons/jobs-educationlevel.svg';
import '../assets/img/icons/jobs-hours.svg';
import '../assets/img/icons/jobs-location.svg';
import '../assets/img/icons/jobs-salary.svg';
import '../assets/img/icons/jobs-vacationdays.svg';
import '../assets/img/icons/jobs-workenvironment.svg';
import '../assets/img/icons/jobs-workingfromhome.svg';
import '../assets/img/icons/linkedin.svg';
import '../assets/img/icons/location.svg';
import '../assets/img/icons/lock.svg';
import '../assets/img/icons/minus-circle.svg';
import '../assets/img/icons/phone.svg';
import '../assets/img/icons/pinterest.svg';
import '../assets/img/icons/play.svg';
import '../assets/img/icons/plus-circle.svg';
import '../assets/img/icons/search.svg';
import '../assets/img/icons/share.svg';
import '../assets/img/icons/sparkles.svg';
import '../assets/img/icons/tiktok.svg';
import '../assets/img/icons/utility-brandwerend.svg';
import '../assets/img/icons/utility-geluidswerend.svg';
import '../assets/img/icons/utility-geluidwerend.svg';
import '../assets/img/icons/utility-inbraakwerend.svg';
import '../assets/img/icons/utility-isolerend.svg';
import '../assets/img/icons/utility-rookwerend.svg';
import '../assets/img/icons/whatsapp.svg';
import '../assets/img/icons/x-mark-circle.svg';
import '../assets/img/icons/youtube.svg';

// Start Stimulus
const application = Application.start();
StimulusControllerResolver.install(application, async (controllerName) => (
  (await import(`./controllers/${controllerName}_controller.js`)).default
));

// Start Turbo
Turbo.start();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR'); // eslint-disable-line no-console
  });
}
